import { MutableRefObject } from 'react'
import { RectangularInputFormatNumberSmall } from '..'
import { useMeasureShortsDictionary } from '../../../utils/hooks/useMeasureDictionary'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'
import { CustomChangeFunction } from '../types'

export interface InputQuantityProps {
    readOnly?: boolean
    typeQuantity: string
    onChange?: CustomChangeFunction
    value: number | string
    onBlur?: React.FocusEventHandler<HTMLInputElement>
    minValue?: number
    maxValue?: number
    myref?: MutableRefObject<any>
    allowNegatives?: boolean
}

const InputQuantity: React.FC<InputQuantityProps> = ({ value, readOnly, typeQuantity, ...rest }) => {
    const { t } = useTwinTranslation()
    const { measureItems } = useMeasureShortsDictionary()
    
    let tag = typeQuantity
    if (String(typeQuantity) === '0' || !typeQuantity){
        tag = t('u', 'u')
    } else if (measureItems[typeQuantity]){
        tag = measureItems[typeQuantity]
    }
    
    return (
        <div className='flex items-center input_quantity'>
            <RectangularInputFormatNumberSmall value={readOnly && !value && value !== 0 ? '' : value} readOnly={readOnly} {...rest} />
            <span className='ml-10'>{tag}</span>
        </div>
    )
}

export default InputQuantity